<template>
  <v-container fluid style="padding-top: 0;">
    <v-row>
      <v-col cols="12" sm="12" md="8" class="py-0 order-2 order-md-1">
        <v-row>
          <v-col cols="12" sm="12" md="6" class="py-0 search-space">
            <v-text-field
              filled
              prepend-inner-icon="mdi-magnify"
              label="Buscar"
              v-model="search"
              dense
              @keyup.enter="HandlerGetProducts(1)"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="6" class="py-0 search-space">
            <v-combobox
              v-model="selectedBrands"
              :items="brands"
              label="Marcas"
              dense
              filled
              multiple
              small-chips
              background-color="transparent"
              clearable
            ></v-combobox>
          </v-col>
        </v-row>
        <v-row>
          <v-col sm="12" md="12" class="pt-2">
            <div v-if="searchProducts">
              <v-row v-if="itemsPublications.length > 0">
                <v-col
                  v-for="(item, index) in itemsPublications"
                  :key="index"
                  cols="12"
                  class="py-1"
                >
                  <v-card
                    class="shadow-small"
                    style="width: 100%; border-radius:10px"
                  >
                    <v-card-text class="py-2">
                      <v-row class="align-center">
                        <v-col cols="6" sm="3">
                          <v-row class="align-center">
                            <v-col
                              cols="6"
                              @click="details(item)"
                              role="button"
                              class="pr-0 py-0 name-item-text"
                            >
                              {{ item.title }}
                            </v-col>
                            <v-col cols="6" class="pr-0 py-0">
                              <img
                                v-if="item.pictures == null"
                                :aspect-ratio="4 / 3"
                                height="100"
                                width="100%"
                                contain
                                src="../../../assets/no_image.jpg"
                                alt="noImage"
                              />
                              <v-img
                                v-else
                                height="100"
                                :lazy-src="item.pictures[0]"
                                :src="item.pictures[0]"
                                class="grey lighten-2"
                              >
                                <template v-slot:placeholder>
                                  <v-row
                                    class="fill-height ma-0"
                                    align="center"
                                    justify="center"
                                  >
                                    <v-progress-circular
                                      indeterminate
                                      color="grey lighten-5"
                                    ></v-progress-circular>
                                  </v-row>
                                </template>
                              </v-img>
                            </v-col>
                          </v-row>
                        </v-col>
                        <v-col cols="6" sm="2">
                          <v-slider
                            step="1"
                            min="0"
                            :max="item.purchase_options.length - 1"
                            thumb-label="always"
                            v-model="stepQuantityList[index]"
                            tick-size="2"
                            ticks="always"
                            color="#6400D2"
                            track-color="rgba(100, 0, 210, 0.35)"
                            class="medium-slider"
                          >
                            <template v-slot:thumb-label="{ value }">
                              {{ item.purchase_options[value].quantity }}
                            </template>
                          </v-slider>
                        </v-col>
                        <v-col cols="5" sm="3">
                          <v-row class="pl-2 pl-sm-0">
                            <div class="detail-text2">PVC:</div>
                            <div class="amount-text2">
                              ${{
                                getPvcWithDiscount(item, index) | number_format
                              }}
                              + IVA ({{ item.iva }})%
                            </div>
                          </v-row>
                          <v-row class="pl-2 pl-sm-0">
                            <div class="detail-text2">MUP:</div>
                            <div class="amount-text2">
                              {{ getMarkUp(item, index) | number_format }}%
                            </div>
                          </v-row>
                          <v-row class="pl-2 pl-sm-0">
                            <div class="detail-text2">PVP:</div>
                            <div class="amount-text2">
                              ${{ item.pvp_with_discount | number_format }}
                            </div>
                          </v-row>
                          <v-row class="pl-2 pl-sm-0">
                            <div class="detail-text2 mb-0">Descuento:</div>
                            <div class="amount-text2 mb-0">
                              {{
                                item.purchase_options[stepQuantityList[index]]
                                  .discount_percentage
                              }}%
                            </div>
                          </v-row>
                        </v-col>
                        <v-col
                          cols="3"
                          sm="2"
                          class="pl-0 d-flex flex-column justify-center align-center"
                        >
                          <div class="amount-text2">Subtotal Item</div>
                          <div class="amount-text2">
                            ${{ getSubtotal(item, index) | number_format }}
                          </div>
                          <div class="amount-text2 mb-0">
                            + IVA {{ item.iva }}%
                          </div>
                        </v-col>
                        <v-col
                          cols="4"
                          sm="2"
                          class="d-flex flex-column justify-center align-center pl-0 py-0"
                        >
                          <div class="availability-box">
                            <div
                              :style="{ color: getColor(item) }"
                              class="availability-text"
                            >
                              {{ item.stock_text }}
                            </div>
                          </div>
                          <v-btn
                            v-if="item.stock_text !== 'No Disponible'"
                            class="add-btn"
                            @click="() => handlerAddProduct(item, index)"
                            :disabled="disabledAddItemToCarButton(item)"
                            :loading="loadingByIndex === item.id"
                            >AGREGAR</v-btn
                          >
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
              <v-row v-else justify="center">
                <v-col cols="12" md="9" class="d-flex justify-center">
                  <p class="text-center py-10 font-weight-medium">
                    No hay resultados para su busqueda
                  </p>
                </v-col>
              </v-row>
              <v-row justify="center" class="mb-0">
                <v-col v-if="paginationData.lastPage > 1" cols="12" md="8">
                  <div class="text-center">
                    <v-pagination
                      color="#343EC4"
                      v-model="page"
                      :length="paginationData.lastPage"
                      circle
                    ></v-pagination>
                  </div>
                </v-col>
              </v-row>
            </div>
            <v-row v-else>
              <v-col class="mx-auto">
                <looping-rhombuses-spinner
                  class="mx-auto"
                  :animation-duration="2500"
                  :rhombus-size="80"
                  color="#402DCE"
                />
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" sm="12" md="4" class="pl-1 pr-0 py-0 order-1 order-md-2">
        <PurchaseOrder
          :shopping_cart_id="current_cart.id"
          :addProductoArray="addProductoArray"
          :getTotal="getTotal"
          :getIva="getIva"
          @dialog:change="HandlerEvent"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { LoopingRhombusesSpinner } from "epic-spinners";
import PurchaseOrder from "./PurchaseOrder";
import moment from "moment";
import Swal from "sweetalert2";

export default {
  components: {
    PurchaseOrder,
    LoopingRhombusesSpinner,
  },
  data() {
    return {
      seasons: ["Winter", "Spring", "Summer", "Fall"],
      icons: ["mdi-snowflake", "mdi-leaf", "mdi-fire", "mdi-water"],
      loading: false,
      loadingByIndex: null,
      nextURL: null,
      prevURL: null,
      totalPage: null,
      current_page: null,
      searchProducts: false,
      addProductoArray: [],
      idSelectedItems: [],
      getTotal: 0,
      getIva: 0,
      discount_product: 0,
      itemsPerPageArray: [10, 20, 30],
      keys: [],
      sortDesc: false,
      page: 1,
      itemsPerPage: 5,
      sortBy: "name",
      search: "",
      slider_product: 0,
      items: [],
      discount_client: 0,
      current_cart: {},
      stepQuantityList: [0],
      selectedBrands: [],
    };
  },

  filters: {
    dateStart(value) {
      return moment(value)
        .locale("es")
        .format("DD/MM/YYYY");
    },
    number_format(
      value,
      decimals = 2,
      separatorThousands = ".",
      separatorDecimals = ","
    ) {
      let number = parseFloat(value);
      if (!isFinite(number) || (!number && number !== 0)) return "";
      let [integer, decimal] = Math.abs(number)
        .toFixed(decimals)
        .split(".");
      let length = integer.length;
      while (length > 3) {
        length -= 3;
        integer =
          integer.slice(0, length) + separatorThousands + integer.slice(length);
      }
      let sign = number < 0 ? "-" : "";
      return `${sign}${integer}${separatorDecimals}${decimal}`;
    },
  },

  created() {
    this.HandlerGetProducts();
    this.getShoppingCart();
  },

  watch: {
    page(page) {
      this.HandlerGetProducts(page);
    },
    selectedBrands() {
      this.HandlerGetProducts();
    },
  },

  computed: {
    itemsPublications() {
      const items = this.$store.getters["product/ITEMS_PRODUCTS"];
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.stepQuantityList = items.map(() => 0);
      return items;
    },

    cartItems() {
      return this.$store.getters["shoppingCart/GET_CART_ITEMS"];
    },

    itemsDiscount() {
      return this.$store.getters["auth/DISCOUNT_CLIENT"];
    },

    paginationData() {
      return this.$store.getters["product/GET_PAGINATION"];
    },
    brands() {
      return Object.keys(this.$store.getters["shoppingCart/GET_BRANDS"]);
    },
  },

  methods: {
    disabledAddItemToCarButton(item) {
      const cart = this.$store.getters["shoppingCart/GET_CART_ITEMS"];
      if (
        cart.items.filter(
          ({ b2b_publication }) => b2b_publication.id === item.id
        ).length
      ) {
        return true;
      }

      return false;
    },
    getPvcWithDiscount(item, index) {
      const { net_pvc } =
        item.purchase_options[this.stepQuantityList[index]] || {};
      return net_pvc;
    },

    getMarkUp(item, index) {
      const { mark_up } =
        item.purchase_options[this.stepQuantityList[index]] || {};
      return mark_up;
    },

    getSubtotal(item, index) {
      const { net_pvc, quantity } = item.purchase_options[
        this.stepQuantityList[index]
      ];
      return net_pvc * quantity;
    },

    getColor(item) {
      switch (true) {
        case item.stock_text.toLowerCase() == "no disponible":
          return "#D32F2F !important";
        case item.stock_text.toLowerCase() == "disponibilidad baja":
          return "#6400D2 !important";
        case item.stock_text.toLowerCase() == "disponibilidad media":
          return "#ED6C02 !important";
        default:
          return "#343EC4 !important";
      }
    },

    details(product) {
      this.$store.commit("product/SET_ONE_PRODUCT", product);
      this.$router.push({
        name: "product_details",
        query: { id: product.id },
      });
    },

    async getShoppingCart() {
      this.loading = true;
      try {
        await this.$store.dispatch("shoppingCart/GET_SHOPPING_CART");
      } catch (error) {
        Swal.fire({
          title: "Un error ha ocurrido",
          text: "Tenemos problemas para obtener su carrito intente mas tarde",
          icon: "error",
          confirmButtonColor: "#7160ec",
        });
      } finally {
        this.loading = false;
      }
    },

    async handlerAddProduct(item, index) {
      this.loadingByIndex = item.id;
      try {
        const request = {
          shopping_cart_id: this.cartItems.id,
          b2b_purchase_option_id:
            item.purchase_options[this.stepQuantityList[index]].id,
        };
        const response = await this.$store.dispatch(
          "shoppingCart/ADD_PRODUCT_CART",
          request
        );
        if (response) {
          this.getShoppingCart();
          const Toast = Swal.mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 2000,
          });
          Toast.fire({
            icon: "success",
            title: "Se ha añadido este item a tu orden de compra",
          });
        }
      } catch (error) {
        this.$snotify.error("Consulte al administrador del sistema", "Error");
      } finally {
        this.loadingByIndex = null;
      }
    },

    season(val, discount_step_b2b) {
      let discount = this.SliderLabels(discount_step_b2b);
      return discount[val];
    },

    async HandlerGetProducts(page = 1) {
      try {
        this.searchProducts = false;
        const request = {
          page: page,
          per_page: this.itemsPerPage,
          paginate: true,
          brands: this.selectedBrands.map(
            (brand) => this.$store.getters["shoppingCart/GET_BRANDS"][brand]
          ),
          search: this.search,
        };
        this.page = page;
        await this.$store.dispatch("product/GET_CATALOG_PRODUCTS", request);
        this.searchProducts = true;
      } catch (error) {
        this.searchProducts = false;
        this.$snotify.error("Consulte al administrador del sistema", "Error");
      } finally {
        this.searchProducts = true;
      }
    },

    async getBrands() {
      const response = await this.$store.dispatch("product/BRANDS");
      this.keys = response;
    },

    HandlerAddItem(item) {
      if (this.addProductoArray.length <= 10) {
        this.idSelectedItems.push(item.id);

        // console.log('this.idSelectedItems',this.idSelectedItems)

        let data_product = item.discount_step_b2b[item.slider_product - 1];

        let discount_product =
          data_product == undefined ? 0 : data_product.discount;

        let pvc = this.PVC(
          item.pvc,
          item.discount_step_b2b,
          item.slider_product
        );

        let sendValue = {
          stock_text: item.stock_text,
          sku: item.sku,
          id: item.id,
          title: item.title,
          pvc: item.pvc,
          sub_pvc: pvc,
          // pvp: this.PVP(item.pvp, item.pvp_without_iva),
          pvp: item.pvp,
          mup: this.MUP(item),
          discount: discount_product,
          quantity: data_product.quantity,
          iva: item.iva,
          avatar: item.pictures[0],
          selectItem: data_product.quantity,
          post_id: item.id,
        };

        this.registerOrUpdateCar(sendValue);
      } else {
        this.$snotify.warning(
          "No puede agregar mas de 10 productos",
          "Seleccion"
        );
      }
    },

    updateItemsPerPage(number) {
      this.itemsPerPage = number;
    },

    SliderLabels(discount) {
      let data;
      if (discount.length > 0) {
        data = discount.map((index) => {
          return index.quantity;
        });

        data.splice(0, 0, 0);
      } else {
        data = [0];
      }
      return data;
    },

    SliderMax(discount) {
      let count;
      let quantity;
      if (discount.length > 0) {
        count = discount.length - 1;
        quantity = discount[count].quantity;
      } else {
        quantity = 0;
      }

      return quantity;
    },

    SliderStep(discount) {
      let quantity;
      if (discount.length > 0) {
        quantity = discount[0].quantity;
      } else {
        quantity = 0;
      }

      return quantity;
    },

    PVC(pvc, discount, slider_product) {
      let pvc_total = 0;
      let pvc_total_discount = 0;
      if (slider_product > 0) {
        // let data_product = discount.find(index => {
        //   return index.quantity == slider_product;
        // });

        let data_product = discount[slider_product - 1];

        let discount_product =
          data_product == undefined ? 0 : data_product.discount;

        pvc_total_discount =
          (pvc - (pvc * discount_product) / 100) * data_product.quantity;

        pvc_total =
          pvc_total_discount - pvc_total_discount * (this.itemsDiscount / 100);
      }
      return pvc_total;
    },

    PVC_TOTAL(pvc, discount, slider_product) {
      let pvc_total = 0;
      let pvc_total_discount = 0;
      if (slider_product > 0) {
        // let data_product = discount.find(index => {
        //   return index.quantity == slider_product;
        // });

        // let data_product = discount[slider_product - 1];

        // let discount_product =
        //   data_product == undefined ? 0 : data_product.discount;

        pvc_total_discount = (pvc - (pvc * discount) / 100) * slider_product;

        pvc_total = pvc_total_discount;
      }
      return pvc_total;
    },

    MUP(item) {
      let MUP = 0;
      if (item.pvp > 0 && item.pvc > 0) {
        let pvc = this.PVC_MUP(item);
        // MUP = ((item.pvp - pvc) / item.pvp) * 100;
        // MUP = ((item.pvp_without_iva / item.pvc) - 100)

        MUP = (item.pvp_without_iva / pvc - 1) * 100;
      }
      return MUP.toFixed(2);
    },

    PVC_MUP(item) {
      let discount_product = this.Discount(
        item.pvc,
        item.discount_step_b2b,
        item.slider_product
      );

      let data = item.pvc - discount_product;

      return data;
    },
    Discount(pvc, discount, slider_product) {
      let pvc_total = 0;
      if (slider_product > 0) {
        let data_product = discount[slider_product - 1];

        let discount_product =
          data_product == undefined ? 0 : data_product.discount;

        pvc_total = pvc * (discount_product / 100);
      }
      return pvc_total;
    },
    PVP(pvp, pvp_without_iva) {
      return pvp == null ? 0 : pvp * (pvp_without_iva / 100 + 1);
    },

    async getCurrentCart() {
      try {
        const response = await this.$store.dispatch(
          "shoppingCart/GET_CURRENT_CART"
        );

        const data = response.data.data;

        this.current_cart = data;

        for (const item of data.shopping_cart_items) {
          let sendValue = {
            stock_text: item.stock_text,
            sku: item.publication_b2b.product.sku,
            id: item.publication_b2b.product.id,
            post_id: item.publication_b2b.id,
            title: item.publication_b2b.keywords,
            pvc: item.pvc,
            sub_pvc: item.pvc_unit,
            pvp: item.pvp,
            mup: item.mup,
            discount: item.discount,
            quantity: item.quantity,
            iva: item.iva,
            avatar: item.publication_b2b.product.images[0],
            selectItem: item.quantity,
          };
          this.addProductoArray.push(sendValue);
        }
      } catch (error) {
        Swal.fire({
          title: "Un error ha ocurrido",
          text: "Tenemos problemas para obtener su carrito intente mas tarde",
          icon: "error",
          confirmButtonColor: "#7160ec",
        });
      }
    },

    async registerOrUpdateCar(item) {
      try {
        const array_product = [...this.addProductoArray];
        array_product.push(item);
        let itemValue = [];
        if (array_product.length > 0) {
          itemValue = array_product.map((value) => {
            return {
              post_id: value.post_id,
              quantity: value.selectItem,
              pvc: value.sub_pvc / value.selectItem,
              // pvc: this.PVC_TOTAL(value.pvc, value.discount, value.quantity),
              pvp: value.pvp,
              mup: value.mup,
              discount: value.discount,
              iva: value.iva,
            };
          });
        } else {
          itemValue = [
            {
              post_id: item.id,
              quantity: item.selectItem,
              pvc: item.sub_pvc / item.selectItem,
              // pvc: this.PVC_TOTAL(item.pvc, item.discount, item.quantity),
              pvp: item.pvp,
              mup: item.mup,
              discount: item.discount,
              iva: item.iva,
            },
          ];
        }

        const request = {
          shopping_cart_id: this.current_cart.id,
          items: itemValue,
          total_amount: itemValue.reduce((acc, out) => {
            acc = acc + out.pvc * out.quantity;
            return acc;
          }, 0),
          total_with_discount: this.getTotal,
        };

        await this.$store.dispatch(
          "shoppingCart/CREATE_SHOOPING_CART",
          request
        );

        this.addProductoArray.push(item);
        this.getTotal = this.addProductoArray.reduce((acc, cnt) => {
          return acc + cnt.sub_pvc;
        }, 0);
        // descuento al cliente
        this.discount_client = (this.getTotal * this.itemsDiscount) / 100;

        this.getIva = item.iva;
      } catch (error) {
        if (error.response.status == 422) {
          Swal.fire({
            title: "Un error ha ocurrido",
            text: error.response.data.errors[0].message,
            icon: "error",
            confirmButtonColor: "#7160ec",
          });
        }
        console.log("error", error);
      }
    },

    async HandlerEvent(item) {
      try {
        this.addProductoArray.splice(this.addProductoArray.indexOf(item), 1);
        this.idSelectedItems.splice(this.idSelectedItems.indexOf(item.id), 1);

        //Validar aca esto
        // this.getTotal = this.getTotal - item.sub_pvc;
        // this.getIva = item.iva;

        const request = {
          shopping_cart_id: this.current_cart.id,
          items: [...this.addProductoArray],
          total_amount: this.getTotal,
          total_with_discount: this.getTotal,
        };

        await this.$store.dispatch(
          "shoppingCart/CREATE_SHOOPING_CART",
          request
        );

        Swal.fire({
          title: "Exitos !",
          text: "Has eliminado el producto",
          icon: "success",
          confirmButtonColor: "#7160ec",
        });
      } catch (error) {
        Swal.fire({
          title: "Error !",
          text: "Ha ocurrido un error intente mas tarde",
          icon: "error",
          confirmButtonColor: "#7160ec",
        });
      }
    },
  },
};
</script>

<style>
.font-text-12 {
  font-size: 12px;
}
.stock {
  background-color: #eee;
  padding: 3px;
  border-radius: 10px;
}
.bg-green {
  color: #04b29b;
}
.bg-yellow {
  color: #f09804;
}
.bg-blue {
  color: #184199;
}
.bg-red {
  color: #c72b27;
}
.bg-pink {
  color: #d81b60;
}
.medium-slider .v-slider__thumb-label {
  height: 18px !important;
  width: 18px !important;
}
.medium-slider .v-input__slot {
  margin-bottom: 0 !important;
}
.medium-slider .v-messages {
  display: none !important;
}
.medium-slider .v-slider__thumb-label {
  font-size: 0.65rem !important;
}
.medium-slider .v-slider__track-container {
  height: 4px !important;
}
.medium-slider .v-slider__thumb {
  cursor: pointer !important;
}
.detail-text2 {
  font-size: 15px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.6);
  margin-bottom: 6px;
}
.amount-text2 {
  font-size: 15px;
  font-weight: 700;
  color: rgba(0, 0, 0, 0.6);
  margin-bottom: 6px;
  margin-left: 4px;
  text-align: center;
}
.availability-text {
  font-weight: 500;
  font-size: 12px;
  text-align: center;
  text-transform: capitalize;
}
.add-btn {
  height: 30px !important;
  background-color: #6400d2 !important;
  color: white !important;
  font-size: 12px !important;
  padding: 0px 10px !important;
}
.availability-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 6px 16px;
  background-color: #eff0f0;
  border-radius: 10px;
  margin-bottom: 14px;
}
.search-space {
  margin-bottom: -14px;
}
.name-item-text {
  font-size: 16px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.6);
  text-transform: capitalize;
}
</style>
